namespace GeniuzPOS.QRreport {
    export interface QRywcSpecReportCusSaleComparisonForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        SupplId: Serenity.LookupEditor;
        SkuCode: Serenity.LookupEditor;
        ConsignFg: Serenity.EnumEditor;
        pSequenFg: Serenity.RadioButtonEditor;
    }

    export class QRywcSpecReportCusSaleComparisonForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecReportCusSaleComparison';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecReportCusSaleComparisonForm.init)  {
                QRywcSpecReportCusSaleComparisonForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;
                var w4 = s.EnumEditor;
                var w5 = s.RadioButtonEditor;

                Q.initFormType(QRywcSpecReportCusSaleComparisonForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'SupplId', w0,
                    'SkuCode', w0,
                    'ConsignFg', w4,
                    'pSequenFg', w5
                ]);
            }
        }
    }
}
